<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          商品类型
        </div>
        <el-select
          v-model="searchForm.productType"
          placeholder="请选择商品类型"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in productTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <div class="label">
          状态
        </div>
        <el-select
          v-model="searchForm.valid"
          placeholder="请选择商品状态"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in productStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="r">
        <el-input
          v-model="searchForm.productName"
          placeholder="请输入商品名称"
          @keyup.enter.native="getList()"
        >
          <el-button
            slot="append"
            type="primary"
            @click="getList()"
          >
            搜索
          </el-button>
        </el-input>
        <el-button
          type="primary"
          @click="create(null)"
        >
          新建商品
        </el-button>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :table-column="tableColumn"
      :pagination="true"
      @changeBypagination="tableHandle"
      @buttonClick="buttonClick"
      @sortChange="sortChange"
    />
    <product-dialog
      :dialog-visible.sync="dialogVisible"
      :item.sync="productItem"
      @confirm="getList()"
    />
  </div>
</template>

<script>
import { } from 'vuex';
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import productDialog from '@/components/common/productDialog.vue';
import types, { productStatusList, productTypeList } from '@/config';

export default {
  name: 'Home',
  components: {
    dataTable,
    productDialog,
  },
  data() {
    return {
      productStatusList,
      productTypeList,
      dialogVisible: false,
      tabelData: {},
      productItem: null,
      pageNum: 1,
      pageSize: 10,
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        valid: '',
        productName: '',
        productType: '',
        sortType: null,
      },
      tableColumn: [
        {
          key: 'productName',
          label: '商品名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'pointsPrice',
          label: '消费积分',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'productDesc',
          label: '商品简介',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'productType',
          label: '商品类型',
          width: 'auto',
          dataType: 'function',
          renderProps: '',
          render: (key) => productTypeList.filter((item) => item.value === key),
        },
        {
          key: 'valid',
          label: '状态',
          width: 'auto',
          dataType: 'component',
          renderProps: { [types.PRODUCT_ENABLE]: '上架', [types.PRODUCT_DISABLE]: '下架', successKey: types.PRODUCT_ENABLE },
          render: () => 'status',
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: 'auto',
          dataType: 'time',
          sortable: 'custom',
        },
        {
          key: 'control',
          label: '操作',
          width: 'auto',
          dataType: 'component',
          renderProps: [
            {
              text: '下架', renderKey: types.PRODUCT_ENABLE, renderProp: 'valid', eventIndex: 0, disableKey: null,
            },
            {
              text: '上架', renderKey: types.PRODUCT_DISABLE, renderProp: 'valid', type: 'success', eventIndex: 0, disableKey: null,
            },
            {
              text: '编辑', renderKey: null, type: 'primary', eventIndex: 1, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.points.getPagePointsProduct(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // 新增商品
    create(item) {
      this.productItem = item;
      this.dialogVisible = true;
    },
    // 下架/上架 商品
    confirmDialog(item) {
      this.$confirm('确定下架/上架该商品？', '下架/上架商品', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id, valid } = item;
        const data = await axClient.points.updateValidPointsProduct(
          {
            id,
            valid: valid === types.INDENTITY_VALID_ENABLE
              ? types.INDENTITY_VALID_DISABLE : types.INDENTITY_VALID_ENABLE,
          },
        );
        if (data) {
          this.$message.success('上架/下架成功');
          this.getList();
        }
      });
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.confirmDialog(item);
          break;
        case 1:
          this.create(item);
          break;
        default:
          break;
      }
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(this.searchForm.pageNum);
    },
    // table sortChange
    sortChange(data) {
      const { prop, order } = data;
      const sortType = {
        createTime: {
          ascending: 10,
          descending: 20,
        },
      };
      this.searchForm.sortType = sortType[prop][order];
      this.getList();
    },
  },
};
</script>
